import React from "react";
import "./HowToParticipate.css";
import {isMobile} from "react-device-detect";
import {arrow_line, four, one, three, two} from "./images";

const HowToParticipate = (props) => {


    return (
        <div style={{zIndex: 10, display: "flex", justifyContent: "center", flexDirection: 'column'}}>
            <p style={{marginTop: 0}} className={"main-text"}>How to Participate</p>
            <div className={"participate-block"}>
                <div style={{display: "flex", flexDirection: isMobile ? "column": "row", gap: 25}}>
                    <div style={isMobile ? {} : {flex: 1}} className={"participate-normal"}>
                        <p className={'participate-counter-text'}>01</p>
                        <p className={'participate-title-text'}>Signup</p>
                        <p className={'participate-text'}>If you're not already a member of TradeX or PRDT Finance, sign up for an account on both platforms.</p>
                        <p className={'participate-sub-text'}>New users on TradeX will receive 2500 token points upon signup to kickstart their trading journey.</p>
                    </div>
                    <div style={isMobile ? {} : {flex: 1}}  className={"participate-normal"}>
                        <p className={'participate-counter-text'}>02</p>
                        <p className={'participate-title-text'}>Trade</p>
                        <p className={'participate-text'}>Start trading on both TradeX and PRDT Finance platforms during the contest period.</p>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: isMobile ? "column-reverse": "row", gap: 25}}>
                    <div style={isMobile ? {} : {flex: 1}}  className={"participate-normal"}>
                        <p className={'participate-counter-text'}>04</p>
                        <p className={'participate-title-text'}>Stay Updated</p>
                        <p className={'participate-text'}>Keep an eye on the leaderboard updates and contest announcements on both platforms to track your progress and stay informed about the competition.</p>
                    </div>
                    <div style={isMobile ? {} : {flex: 1}} className={"participate-normal"}>
                        <p className={'participate-counter-text'}>03</p>
                        <p className={'participate-title-text'}>Compete</p>
                        <p className={'participate-text'}>Your trading performance will be automatically tracked, and your position on the leaderboard will be determined by your trading activity and profits.</p>
                    </div>
                </div>

            </div>
        </div>
    );
};



export default (HowToParticipate);
